window.addEventListener("load", function () {
  new Swiper(".swiper-update", {});
});